module.exports = __webpack_public_path__ + "static/media/building.e72d7316.png";